/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { toUrlEncodedString } from '@/features/reviews/utils/toUrlEncodedString';

export const getStoreWazeURL = (storeLocationParams: { latitude: number; longitude: number }) => {
  const wazeQuery = toUrlEncodedString({
    ll: `${storeLocationParams.latitude},${storeLocationParams.longitude}`,
    navigate: 'yes',
    zoom: 17,
  });

  return 'https://www.waze.com/ul?' + wazeQuery;
};
